import { memo, useCallback } from "react";

import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { OfficesSearchFilterProps } from "./types";

import { useTranslate } from "helpers";
import { initialOfficeSearchForm } from "services/api/offices/consts";

const OfficesSearchFilters: React.FC<OfficesSearchFilterProps> = (props) => {
  const { formValues, onAddNew, onSearchChange } = props;
  const { t } = useTranslate();

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onSearchChange({ ...formValues, search: e.target.value });
  };

  const handleResetFormClick = useCallback(() => {
    onSearchChange(initialOfficeSearchForm);
  }, [onSearchChange]);

  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center ">
          <div className="flex flex-wrap gap-3">
            <div className="">
              <TextField
                type="text"
                name="search"
                value={formValues.search}
                onChange={handleSearchChange}
                placeholder={t("admin.search.placeholder")}
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>
            <div className="mr-3 flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                {t("admin.reset")}
              </span>
            </div>
          </div>
          <div className=" py-3 flex justify-end ">
            <Button
              variant="primary"
              children="Dodaj poslovnicu"
              startIcon="/media/icons/plus.svg"
              onClick={onAddNew}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(OfficesSearchFilters);
